"use strict";

exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.13.0@element-ui/lib/utils/merge.js
// module id = 136
// module chunks = 115